import { environment } from '../../../environments/environment';
export class BaseUrl {
    public static get BASE_URL(): string { return environment.serviceApi; }
    public static get AUTH_URL(): string { return environment.authConfig.authApi; }
    public static get AUTH_CONFIG(): any { return environment.authConfig; }
    public static get APP_URL(): string { return environment.appUrl; }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/urls/base.url.ts